<template>
  <div class="edit-studio-container">
    <main class="tab-content">
      <h2 class="item text-secondary">KMT country form content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>Country code:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.country_code" />
        </div>
        <div class="field-sec">
          <label>Title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_form_title" />
        </div>
        <div class="field-sec">
          <label>Checkbox title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.checkbox_title" />
        </div>
        <div class="field-sec">
          <label>1 person:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_persons1" />
        </div>
        <div class="field-sec">
          <label>2 persons:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_persons2" />
        </div>
        <div class="field-sec">
          <label>First name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_first_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Last name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_last_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Email placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_email_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Phone placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_phone_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Message placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_msg_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Action code text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_action_code_text" />
        </div>
        <div class="field-sec">
          <label class="">Action code placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_action_code_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Submit button:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.send_btn_text" />
        </div>
        <div class="field-sec">
          <label class="">Thank you page:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.thank_you_page" />
        </div>
      </form>
      <h2 class="item text-secondary">Error messages:</h2>
      <form class="form-container admin-studio-tab-pane fade show active" id="error">
        <div class="field-sec">
          <label class="">First name error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_first" />
        </div>
        <div class="field-sec">
          <label class="">Last name error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_last" />
        </div>
        <div class="field-sec">
          <label class="">First & Last name error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_first_last" />
        </div>
        <div class="field-sec">
          <label class="">Email error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_email" />
        </div>
        <div class="field-sec">
          <label class="">Invalid email error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_email2" />
        </div>
        <div class="field-sec">
          <label class="">Phone error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_phone" />
        </div>
        <div class="field-sec">
          <label class="">Invalid phone error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_phone2" />
        </div>
        <div class="field-sec">
          <label class="">Message error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_des" />
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>

      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <div class="kmt not-fixed" id="fit_studio">
        <div class="right-side-kmt-form not-fixed">
          <h2 id="kmt_form_title_studio" class="kmt-form-title">{{ fit20.blockToEdit.kmt_form_title }}</h2>
          <div id="checkbox" class="checkbox not-fixed">
            <label id="kmt_checkbox_title"> {{ fit20.blockToEdit.checkbox_title }}</label>
            <input type="radio" id="kmt_persons1" name="Person" value="1 Person" checked />
            <label id="kmt_persons1-text" for="kmt_persons1">{{ fit20.blockToEdit.kmt_persons1 }}</label>
            <input type="radio" id="kmt_persons2" name="Person" value="2 Persons" />
            <label id="kmt_persons2-text" for="kmt_persons2">{{ fit20.blockToEdit.kmt_persons2 }}</label>
          </div>
          <form class="" id="form_field">
            <div class="kmt-error-container not-fixed">
              <div class="kmt-error hidden" id="kmt_error"></div>
            </div>
            <ul class="kmt-fields">
              <li>
                <div class="not-fixed">
                  <input id="kmt_first_name" type="text" value="" maxlength="255" fieldType="1"
                    :placeholder="fit20.blockToEdit.kmt_first_name_placeholder" />
                </div>
              </li>
              <li>
                <div class="not-fixed">
                  <input id="kmt_last_name" type="text" maxlength="255"
                    :placeholder="fit20.blockToEdit.kmt_last_name_placeholder" />
                </div>
              </li>
              <li>
                <div class="not-fixed">
                  <input id="kmt_email" type="email" maxlength="255" value=""
                    :placeholder="fit20.blockToEdit.kmt_email_placeholder" />
                </div>
              </li>
              <li>
                <div>
                  <div class="not-fixed">
                    <input id="kmt_phone" type="text" :placeholder="fit20.blockToEdit.kmt_phone_placeholder" />
                  </div>
                </div>
              </li>
              <li>
                <div class="not-fixed">
                  <textarea id="kmt_description" maxlength="65535"
                    :placeholder="fit20.blockToEdit.kmt_msg_placeholder"></textarea>
                </div>
              </li>
              <li>
                <label id="kmt_action_code_text" onclick="">
                  <input class="kmt-action-code-checkbox" type="checkbox" />
                  <span class="checkmark" id="kmt_action_code_checkbox" onclick="">{{
                    fit20.blockToEdit.kmt_action_code_placeholder }}</span>
                </label>
                <input id="kmt_action_code" class="display-none" type="text" placeholder="" />
              </li>
            </ul>
            <div class="zcwf_row not-fixed">
              <div class="reCAPTCHA-text not-fixed">
                This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service
                apply.
              </div>
              <div class="btn-container">
                <div class="btn-div not-fixed">
                  <button data-sitekey="6Lfwco0iAAAAABguhve-qhu-bCyYNTiY8qK2KgTu" data-callback="onSubmit" type="button"
                    id="formsubmit" class="form-submit" onclick="">{{ fit20.blockToEdit.send_btn_text }}</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: 'KmtStudio',
  props: ["fit20", "saveBlock", "cancelEditing"],
};
</script>

<style scoped>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* fit20 form style */
.kmt {
  width: 100%;
  min-height: 600px;
  display: flex;
  background: url('https://www.fit20.com/files/images/Global/Global Grids/FIT02680\ -\ Headers\ website\ iconen\ patronen\ DNA\ -\ fit20\ franchise.png');
}

.kmt section {
  width: 80% !important;
  max-width: 1500px !important;
  margin: auto !important;
  font-family: sans-serif !important;
  background-color: white !important;
  padding: 20px !important;
  border-radius: 20px !important;
}

.kmt h2 {
  margin-top: 0px !important;
  font-size: 40px !important;
}

.kmt ul {
  padding: 0 !important;
}

.kmt .right-side-kmt-form {
  width: 60% !important;
  max-width: 1500px !important;
  margin: auto !important;
  font-family: sans-serif !important;
  background-color: white !important;
  padding: 20px !important;
  border-radius: 20px !important;
}

.kmt .kmt-form-title {
  text-align: center !important;
  color: #616365 !important;
  font-family: 'VAG Rounded Std light', Verdana, Geneva, Tahoma, sans-serif !important;
}

.kmt li {
  padding: 0 !important;
  list-style: none !important;
  line-height: normal !important;
}

.checkbox {
  padding-left: 0px !important;
  line-height: normal !important;
  color: #616365 !important;
  font-size: 14px !important;
  margin-bottom: 15px !important;
}

.checkbox input {
  display: inline !important;
  margin: 0 !important;
  width: 0 !important;
}

.checkbox label {
  display: inline !important;
  padding-left: 3px !important;
  margin-left: 2.5% !important;
}

.kmt .checkbox input[type='radio'] {
  opacity: 0 !important;
  height: 0 !important;
}

.kmt .checkbox input[type='radio']+*::before {
  content: '' !important;
  display: inline-block !important;
  vertical-align: middle !important;
  width: 10px !important;
  height: 10px !important;
  margin-right: 5px !important;
  margin-bottom: 1.3px !important;
  border-radius: 50% !important;
  border-style: solid !important;
  border-width: 2px !important;
  border-color: #5e7fb133 !important;
}

.kmt .checkbox input[type='radio']:checked+*::before {
  content: '' !important;
  display: inline-block !important;
  vertical-align: middle !important;
  width: 10px !important;
  height: 10px !important;
  margin-right: 5px !important;
  border-radius: 50% !important;
  border-style: solid !important;
  border-width: 2px !important;
  border-color: #95c11a !important;
  background: radial-gradient(#95c11a 0%, #95c11a 40%, transparent 50%, transparent) !important;
}

#crmWebToEntityForm.zcwf_lblTopBottom {
  width: 100% !important;
}

.kmt label {
  text-align: left !important;
  padding: 3px 0 3px 10px !important;
  font-size: 14px !important;
}

.kmt .kmt-fields {
  width: 100% !important;
  display: flex !important;
  justify-content: space-around !important;
  flex-wrap: wrap !important;
  padding-left: 10px !important;
  color: #616365 !important;
}

.kmt .kmt-fields li {
  width: 45% !important;
  margin-bottom: 15px !important;
}

.kmt .kmt-fields input {
  width: 100% !important;
  height: 40px !important;
}

.kmt .kmt-fields li:nth-last-child(2),
.kmt .kmt-fields li:last-child {
  width: 95% !important;
}

.kmt .kmt-fields li:last-child {
  display: flex !important;
}

.kmt .kmt-fields li:last-child #kmt_action_code_text {
  display: block !important;
  position: relative !important;
  padding-left: 35px !important;
  margin-bottom: 12px !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  padding-right: 10px !important;
  margin: auto 0;
}

.kmt .kmt-fields .kmt-action-code-checkbox {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.kmt .kmt-fields .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 17px;
  width: 17px;
  background-color: rgb(255, 255, 255);
  border: solid 1px #0000002b;
}

/* When the checkbox is checked, add a blue background */
.kmt .kmt-fields input:checked~.checkmark {
  background-color: #ffffff;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.kmt .kmt-fields input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.kmt .kmt-fields .checkmark:after {
  left: 5px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid #92d400;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.kmt .kmt-fields li:last-child input:last-child {
  width: 73% !important;
}

.kmt .kmt-fields input,
.kmt textarea {
  border: solid 1px #5e7fb133 !important;
  border-radius: 5px !important;
  padding: 3px 0px 3px 10px !important;
  outline: none !important;
  font-size: 14px !important;
}

.kmt textarea {
  width: 100% !important;
  height: 50px !important;
}

.kmt .reCAPTCHA-text {
  text-align: center !important;
  font-size: 11px !important;
  padding: 10px 0 15px 10px !important;
  color: #616365 !important;
}

.kmt .form-submit {
  cursor: pointer !important;
  color: #ffffff !important;
  background-color: #e5007d !important;
  border: solid 1px #e5007d !important;
  font-size: 15px !important;
  border-radius: 20px !important;
  padding: 7px 30px !important;
}

.kmt .form-submit:hover {
  background-color: transparent !important;
  color: #e5007d !important;
  transition: all 0.3s !important;
}

.btn-container {
  width: 100%;
  text-align: center !important;
}

.btn-div {
  display: inline-block !important;
  z-index: 1 !important;
  position: relative;
  margin: 0 auto !important;
  border-radius: 15px !important;
}

.btn-div:after {
  transition: all 0.3s !important;
  content: '' !important;
  background: #ffffff !important;
  border-radius: 15px !important;
  width: 0% !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  height: 100% !important;
  z-index: -1 !important;
}

.btn-div:hover:after {
  width: 100% !important;
}

.hidden {
  display: none !important;
}

.kmt-error {
  border: 1px solid red !important;
  border-radius: 10px !important;
  background-color: rgb(255, 215, 215) !important;
  text-align: center !important;
  font-size: 14px !important;
}

.display-none {
  display: none !important;
}

.kmt .selected {
  transition: all 0.1s !important;
  border: 2px solid #009fe3 !important;
}

@media only screen and (max-width: 900px) {
  .kmt .kmt-fields li:last-child #kmt_action_code_text {
    display: inline-block !important;
    width: 35% !important;
  }

  .kmt .kmt-fields li:last-child input:last-child {
    width: 63% !important;
  }
}

@media only screen and (max-width: 700px) {
  .kmt section {
    padding: 10px !important;
  }

  .kmt h2 {
    margin-top: 0px !important;
    font-size: 14px !important;
  }

  .kmt ul {
    padding: 0 !important;
  }

  .kmt .right-side-kmt-form {
    width: 80% !important;
  }

  .checkbox {
    font-size: 10px !important;
  }

  .checkbox label {
    display: block !important;
    font-size: 10px !important;
  }

  .kmt label {
    padding: 3px 0 3px 10px !important;
  }

  .kmt .kmt-fields {
    padding-left: 5px !important;
  }

  .kmt .kmt-fields input,
  .kmt .kmt-fields textarea,
  .kmt .kmt-fields label {
    font-size: 10px !important;
  }

  .kmt .kmt-fields li {
    width: 95% !important;
    margin-bottom: 5px !important;
  }

  .kmt .kmt-fields li:last-child #kmt_action_code_text {
    width: 95% !important;
  }

  .kmt .kmt-fields li:last-child input:last-child {
    width: 95% !important;
  }

  .kmt .reCAPTCHA-text {
    font-size: 9px !important;
    padding: 5px 0 5px 10px !important;
  }

  .kmt .form-submit {
    font-size: 12px !important;
    padding: 5px 20px !important;
  }

  .hidden {
    display: none !important;
  }

  .kmt-error {
    border: 1px solid red !important;
    border-radius: 10px !important;
    background-color: rgb(255, 215, 215) !important;
    text-align: center !important;
    font-size: 10px !important;
  }
}
</style>
